module.exports = __webpack_public_path__ + "img/gateway10.4044a7bf.png";